<template>
  <li :class="swiperClass">
    <a href="#" @click.prevent="()=>sendLogAndGoDetail($event)" :aria-label="altTitle">
      <div class="inner-wrap" aria-hidden="true">
        <div class="picture-area">
          <WebpImage :image-info="{imageUrl: cellInfo.thumbnail, width: thumbnailInfo.width, height: thumbnailInfo.height, alt: altTitle, onImageLoad}" />
          <age-tag v-if="hasAgeTag" :age-code="cellInfo.age_tag"/>
          <ul class="badge-list">
            <li class="left-top-area">
              <ul v-top-tag-list="{ badgeList: topTagList, badgeType: 'artwork' }"></ul>
            </li>
            <template v-if="cellType === 'coming-soon'">
             <li class="right-top-area" v-common-tag-list="{'badgeList': brandTagList, 'type': 'brand'}"></li>
            </template>
<!--            <li class="center-bottom-area" v-common-tag-list="{'badgeList': updateTagList, 'type': 'label'}"></li>-->
          </ul>
          <!--TODO:// 썸네일이 없는 경우, 노출되는 타이틀-->
          <div :class="altClassName">
            <span>{{ alt }}</span>
          </div>
          <div class="progress" v-if="isProgress">
            <span class="progress-meter" v-progress-bar="progress * 100">&nbsp;</span>
          </div>
        </div>

        <!--TODO: api 나오면 title 노출 여부 처리-->
        <div class="cell-info">
          <div class="cell-title-wrap" v-title-list="{ titleList: titleList }"></div>
        </div>
      </div>
    </a>
    <button type="button" v-if="hasInformationBtn" @click.prevent="goToContentInfo" class="btn-detail-view">상세 더보기</button>
    <icon-box-zzim-with-event v-if="cellType === 'coming-soon' && !isImageBand" :event-list="eventList" :zzim="zzim"></icon-box-zzim-with-event>
  </li>
</template>
<script>
import { progressBar, titleList, topTagList, commonTagList } from '@/common/directives'
import { get } from 'lodash'
import IconBoxZzimWithEvent from '@/components/play/IconBoxZzimWithEvent'
import cellMixin from '@/common/mixin/cell.mixin'
import { LOG_SEND_LIST } from '@/common/resources/log.v2.const'
import AgeTag from '@/components/tags/AgeTag'
import WebpImage from '@/components/image/WebpImage'
import { getEventListByType } from '@/common/util/event.util'
import { parseUrl } from 'query-string'
import { PATH_NAME_PLAYER } from '@/common/router.const'

export default {
  name: 'LandscapeCell',
  props: {
    cellInfo: {
      type: Object
    },
    thumbnailInfo: {
      type: Object
    },
    cellIndex: {
      type: Number
    }
  },
  components: {
    WebpImage,
    IconBoxZzimWithEvent,
    AgeTag
  },
  directives: {
    progressBar,
    titleList,
    topTagList,
    commonTagList
  },
  mixins: [cellMixin],
  data () {
    return {
      cellType: 'episode',
      isImageBand: false
    }
  },
  computed: {
    swiperClass () {
      let className = `swiper-slide `
      const isMyview = get(this.thumbnailInfo, 'cellType', '') === 'band_myview'
      const isWatching = (this.cellType === 'coming-soon' && get(this.cellInfo, 'event_list', []).length > 0) ||
        isMyview
      return `${className} ${isMyview ? '' : this.cellType} ${isWatching ? 'watching' : ''}`
    },
    hasInformationBtn () {
      const { onDetail } = getEventListByType(get(this.cellInfo, 'event_list', []))
      return get(onDetail, 'cta', '').toLowerCase() === 'icon_information'
    },
    hasAgeTag () {
      return get(this.cellInfo, 'age_tag', '') !== ''
    }
  },
  methods: {
    sendLogAndGoDetail ($e) {
      if (LOG_SEND_LIST.includes(this.$route.name)) {
        this.$emit('cell-click-log', { cellInfo: this.cellInfo, index: this.cellIndex, routeName: this.$route.name })
      }
      if ($e.target.offsetParent.className === 'cell-info' && get(this.thumbnailInfo, 'cellType', '') === 'band_myview') {
        this.goToContentInfo()
      } else {
        this.selectCell()
      }
    },
    goToContentInfo () {
      const { onDetail } = getEventListByType(get(this.cellInfo, 'event_list', []))
      let { url, query } = parseUrl(get(onDetail, 'url', ''))
      const section = url.split('/').pop()
      this.$router.push({
        name: PATH_NAME_PLAYER,
        params: { section },
        query
      })
    }
  },
  created () {
    const cellType = get(this.thumbnailInfo, 'cellType', '')
    this.isImageBand = get(this.cellInfo, 'event_list', []).length === 0 && cellType === 'band_82'
    if (cellType === 'band_82') {
      this.cellType = 'coming-soon'
    }
  }
}
</script>
